import { QBankStructureLevelTag } from '@exam-management/components';
import { QBankStructureLevelCategory } from '@exam-management/graphql';
import { type FlexProps, Box, Divider, Flex, mergeSx, Text } from '@shared/components';
import { useOutletContext } from 'react-router-dom';

import { QBankStructureLevelItemFormAction } from '../../constants';
import type { ActionOutletContextType } from '../../types';
import { QBankStructureLevelItemNameInput } from '../qbank-structure-level-item-name-input';

export interface QBankStructureLevelItemRowProps {
  category: QBankStructureLevelCategory;
  order: number;
  name: string;
  defaultNameValue?: string;
  startAdornment?: React.ReactNode;
  endAdornment?: React.ReactNode;
  editable?: boolean;
  wrapperProps?: FlexProps;
  placeholder?: string;
  dataTestId?: string;
  expanded?: boolean;
  nonInfo?: boolean;
}

export default function QBankStructureLevelItemRow(
  props: Readonly<QBankStructureLevelItemRowProps>,
) {
  const {
    category,
    order,
    name,
    startAdornment,
    endAdornment,
    wrapperProps: { sx, ...wrapperProps } = {},
    dataTestId,
    editable: isEditable = true,
    expanded: isExpanded = false,
    nonInfo: isNonInfo,
    placeholder,
  } = props;
  const { action: listAction } = useOutletContext<ActionOutletContextType>();

  return (
    <>
      {startAdornment}
      <Flex
        data-testid={dataTestId}
        sx={mergeSx(
          (theme) => ({
            alignItems: 'center',
            px:
              category === QBankStructureLevelCategory.SubTopic ||
              listAction === QBankStructureLevelItemFormAction.EDIT
                ? theme.spacing(3)
                : 0,
          }),
          sx,
        )}
        {...wrapperProps}
      >
        <Flex
          sx={{
            alignItems: 'center',
          }}
        >
          <QBankStructureLevelTag category={category} />
        </Flex>
        <Text variant='body2Semibold' sx={{ px: (theme) => theme.spacing(2.5) }}>
          {order}
        </Text>
        <Divider
          orientation='vertical'
          sx={{
            height: '20px',
            bgcolor: (theme) => theme.palette.grey[300],
          }}
        />
        <Box sx={{ flexGrow: 1, px: (theme) => theme.spacing(2) }}>
          <QBankStructureLevelItemNameInput
            name={name}
            placeholder={placeholder}
            disabled={!isEditable}
            category={category}
            expanded={isExpanded}
            nonInfo={isNonInfo}
          />
        </Box>
      </Flex>
      {endAdornment}
    </>
  );
}
